export default function sanitizeRawContent(input: unknown): string {
    if (typeof input !== 'string') return String(input);

    const sensitiveKeys = [
        'password',
        'token',
        'auth',
        'secret',
        'credit_card',
        'email',
        'emailHash'
    ];

    // Regex looks for "key": "value" patterns to redact the value
    const regex = new RegExp(`"(${sensitiveKeys.join('|')})" *: *"[^"]*"`, 'gi');

    return input.replace(regex, '"$1":"[REDACTED]"');
}
